// ** Icons Import
import { Mail, MessageSquare, CheckSquare, Calendar, Circle, Layers, ShoppingCart, User, Shield, StopCircle, Hexagon } from 'react-feather'

import { GrThreeDEffects, GrUserAdd, GrStakeholder, GrTime, GrSend, GrDocumentPpt, GrNodes, GrPrint, GrDesktop, GrDocumentTime, GrBusinessService } from 'react-icons/gr'


export default [
    {
        header: 'Modules'
    },
    {
        id: 'acctgsys',
        title: 'Accounting Entries',
        icon: <GrDesktop />,
        children: [
            {
                id: 'acctbank',
                title: 'Banking',
                icon: <StopCircle/>,
                children: [
                    {
                    id: 'acctbankacct',
                    title: 'Account',
                    icon: <Hexagon/>,
                    navLink: '/apps/accounting/entries/banking/Account'
                    },
                    { id: 'acctbanktransfer',
                    title: 'Transfer',
                    icon: <Hexagon/>,
                    navLink: '/apps/accounting/entries/banking/Transfer'
                    }
                ]
            },     
            {
                id: 'acctincome',
                title: 'Income',
                icon: <StopCircle/>,
                children: [
                    {
                        id: 'acctincinvoice',
                        title: 'Invoice',
                        icon: <Hexagon/>,
                        navLink: '/apps/accounting/entries/income/Invoice'
                    },
                    { 
                        id: 'acctincrevenue',
                        title: 'Revenue',
                        icon: <Hexagon/>,
                        navLink: '/apps/accounting/entries/income/Revenue'
                    },
                    { 
                        id: 'acctinccrednote',
                        title: 'Credit Note',
                        icon: <Hexagon/>,
                        navLink: '/apps/accounting/entries/income/CreditNote'
                    }    
                ]
            },
            {
                id: 'acctexpense',
                title: 'Expense',
                icon: <StopCircle/>,
                children: [
                    {
                        id: 'acctexpbill',
                        title: 'Bill',
                        icon: <Hexagon/>,
                        navLink: '/apps/accounting/entries/expense/Bill'
                    },
                    { 
                        id: 'acctexppayment',
                        title: 'Payment',
                        icon: <Hexagon/>,
                        navLink: '/apps/accounting/entries/expense/Payment'
                    },
                    { 
                        id: 'acctexpdebnote',
                        title: 'Debit Note',
                        icon: <Hexagon/>,
                        navLink: '/apps/accounting/entries/expense/DebitNote'
                    }
                ]
            },
            {
                id: 'acctdoubleent',
                title: 'Double Entry',
                icon: <StopCircle/>,
                children: [
                    {
                        id: 'acctdbletcoa',
                        title: 'Chart of Accounts',
                        icon: <Hexagon/>,
                        navLink: '/apps/accounting/entries/ChartOfAccounts'
                    },
                    { 
                        id: 'acctdbletjourn',
                        title: 'Journal Account',
                        icon: <Hexagon/>,
                        navLink: '/apps/accounting/entries/JournalAcct'
                    },
                    { 
                        id: 'acctdbletledgsumm',
                        title: 'Ledger Summary',
                        icon: <Hexagon/>,
                        navLink: '/apps/accounting/entries/LedgerSumm'
                    },  
                    {
                        id: 'acctdbletbalsheet',
                        title: 'Balance Sheet',
                        icon: <Hexagon/>,
                        navLink: '/apps/accounting/entries/BalSheet'
                    },
                    { 
                        id: 'acctdblettrialbal',
                        title: 'Trial Balance',
                        icon: <Hexagon/>,
                        navLink: '/apps/accounting/entries/TrialBal'
                    }
                    
                ]
            },  
            {
                id: 'acctfingoal',
                title: 'Financial Goal',
                icon: <Hexagon/>,
                navLink: '/apps/accounting/entries/FinGoal'
            },
            {
                id: 'acctacctsetup',
                title: 'Accounting Setup',
                icon: <Hexagon/>,
                navLink: '/apps/accounting/entries/AcctSetup'
            },
            {
                id: 'acctprintset',
                title: 'Print Settings',
                icon: <Hexagon/>,
                navLink: '/apps/config/PrintSetting'
            }

        ]
    },
    {
        id: 'acctgrpt',
        title: 'Accounting Reports',
        icon: <GrPrint/>,
        children: [
            {
                id: 'acctrpt10statement',
                title: 'Account Statement',
                icon: <Layers/>,
                navLink: '/apps/accounting/reports/AccountStatement'
            },
            { 
                id: 'acctrpt20invcsumm',
                title: 'Invoice Summary',
                icon: <Layers/>,
                navLink: '/apps/accounting/reports/InvoiceSummary'
            },
            {
                id: 'acctrpt30billsumm',
                title: 'Bill Summary',
                icon: <Layers/>,
                navLink: '/apps/accounting/reports/BillSummary'
            },
            { 
                id: 'acctrpt40prodstock',
                title: 'Product Stock',
                icon: <Layers/>,
                navLink: '/apps/accounting/reports/ProductStock'
            },
            {
                id: 'acctrpt50profitloss',
                title: 'Profit & Loss',
                icon: <Layers/>,
                navLink: '/apps/accounting/reports/ProfitAndLoss'
            },
            { 
                id: 'acctrpt50transaction',
                title: 'Transaction',
                icon: <Layers/>,
                navLink: '/apps/accounting/reports/TransactionSummary'
            },
            {
                id: 'acctrpt70incsumm',
                title: 'Income Summary',
                icon: <Layers/>,
                navLink: '/apps/accounting/reports/IncomeSummary'
            },
            { 
                id: 'acctrpt80expsumm',
                title: 'Expense Summary',
                icon: <Layers/>,
                navLink: '/apps/accounting/reports/ExpenseSummary'
            },
            {
                id: 'acctrpt90incexp',
                title: 'Income vs Expense',
                icon: <Layers/>,
                navLink: '/apps/accounting/reports/IncomeVsExpense'
            },
            { 
                id: 'acctrpt100taxsumm',
                title: 'Tax Summary',
                icon: <Layers/>,
                navLink: '/apps/accounting/reports/TaxSummary'
            }
        ]
    },
    {
        id: 'customerentry',
        title: 'Customer',
        icon: <GrUserAdd/>,
        navLink: '/apps/customer/entries/list'
    },
    {
        id: 'vendorentry',
        title: 'Vendor',
        icon: <GrStakeholder/>,
        navLink: '/apps/vendor/entries/list'
    },
    {
        id: 'prodsys',
        title: 'Product System',
        icon: <GrBusinessService/>,
        children: [
            {
                id: 'prodsvcs',
                title: 'Product & Services',
                icon: <Hexagon/>,
                navLink: '/apps/product/entries/ProdSvc'
            }
        ]
    },
    {
        id: 'hrdtrentry',
        title: 'HR DTR',
        icon: <GrDocumentTime/>,
        navLink: '/apps/humanresource/entries/DailyTimeRecord'
    },
    {
        id: 'acctproposal',
        title: 'Proposal',
        icon: <GrDocumentPpt/>,
        // navLink: '/apps/accounting/sys/proposal'
        navLink: '/apps/accounting/reports/ProfitAndLoss'
    }
]
